import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { CoreCommonModule } from "@core/common.module";

import { ErrorComponent } from "app/pages/miscellaneous/error/error.component";
import { NotAuthorizedComponent } from "./not-authorized/not-authorized.component";
import { OfflineComponent } from "./offline/offline.component";
import { ComponentsModule } from "../../util/components/components.module";
import { LoadingComponent } from "./loading/loading.component";

// routing
const routes: Routes = [
  {
    path: "error",
    component: ErrorComponent,
  },
  {
    path: "not-authorized",
    component: NotAuthorizedComponent,
  },
  {
    path: "update",
    component: OfflineComponent,
  },
  {
    path: "loading",
    component: LoadingComponent,
  },
];

@NgModule({
  declarations: [ErrorComponent, NotAuthorizedComponent, OfflineComponent],
  imports: [CommonModule, RouterModule.forChild(routes), CoreCommonModule, ComponentsModule],
})
export class MiscellaneousModule {}
